module.exports = __webpack_public_path__ + "assets/img/bilge_pump.d78ff7cc.png";